import { render, staticRenderFns } from "./getpsw.vue?vue&type=template&id=330a4d3e&scoped=true"
import script from "./getpsw.vue?vue&type=script&lang=js"
export * from "./getpsw.vue?vue&type=script&lang=js"
import style0 from "./getpsw.vue?vue&type=style&index=0&id=330a4d3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a4d3e",
  null
  
)

export default component.exports